import type { PayloadAction } from '@reduxjs/toolkit';
import type { ResolvedEmailBlock } from '@/micros/edit-project/grid-areas/main/campaigns/templates/widgets/block-types';
import type { CampaignEditorReducerCreator } from '../types';

// the stored email moved to another template - see campaign-editor-middleware
const setCampaignEditorBlocksForTemplate = (create: CampaignEditorReducerCreator) =>
  create.reducer(
    (state, action: PayloadAction<{ templateId: string | undefined; blocks: ResolvedEmailBlock[] | null }>) => {
      state.templateId = action.payload.templateId;
      state.blocks = action.payload.blocks;
    }
  );

export default setCampaignEditorBlocksForTemplate;
